import { formatReportDateUnix } from "@entities/history";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { ReportRepairProps } from "./types";
import classes from "./report-repair.module.scss";

export const ReportRepair = ({ events, isPdfMode }: ReportRepairProps) => {
    const repairs = events?.filter((e) => e.type === "repairCalculation");

    return (
        <div className={classes.repair}>
            <div className={classes.repair__note}>
                Страховые компании оценивают стоимость ремонта при наступлении страхового случая.
                Это не означает, что автомобиль ремонтировали
            </div>
            {repairs.length === 0 ? (
                <>
                    <div className={classes.repair__label}>Расчёт не проводился</div>
                    <div className={classes.repair__desc}>
                        Это не гарантирует, что автомобиль не ремонтировали, но значит, что его не
                        оценивали через страховые компании. Владельцам КАСКО и ОСАГО страховые
                        компании оценивают стоимость ремонта после ДТП
                    </div>
                </>
            ) : (
                <div className={classes.repair__list}>
                    {repairs.map((repair, idx) => (
                        <FixedAccordion
                            key={idx}
                            expanded={isPdfMode}
                            title={
                                <div className={classes.repair__title}>
                                    Расчет стоимости ремонта от {formatReportDateUnix(repair.date)}
                                    <span className={classes.repair__source}>{repair.source}</span>
                                </div>
                            }
                            content={
                                <div className={classes.repair__content}>
                                    {repair.description ? (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: repair.description
                                            }}
                                        />
                                    ) : (
                                        "Описание отсутствует"
                                    )}
                                </div>
                            }
                        />
                    ))}
                </div>
            )}
        </div>
    );
};